import { Injectable } from '@angular/core';
import {
    collection,
    collectionData,
    doc,
    docData,
    Firestore,
    setDoc,
    updateDoc,
} from '@angular/fire/firestore';
import { from, Observable } from 'rxjs';

export interface User {
    id: string;
    email: string;
    displayName?: string;
    role?: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
    private collectionName = 'users';

    constructor(private firestore: Firestore) {}

    getAllUsers(): Observable<User[]> {
        const colRef = collection(this.firestore, this.collectionName);
        return collectionData(colRef, { idField: 'id' }) as Observable<User[]>;
    }

    getUserById(userId: string): Observable<User | undefined> {
        const docRef = doc(this.firestore, `${this.collectionName}/${userId}`);
        return docData(docRef, { idField: 'id' }) as Observable<User | undefined>;
    }

    addUser(user: User): Observable<void> {
        const docRef = doc(this.firestore, `${this.collectionName}/${user.id}`);
        return from(setDoc(docRef, user));
    }

    updateUser(userId: string, data: Partial<User>): Observable<void> {
        const docRef = doc(this.firestore, `${this.collectionName}/${userId}`);
        return from(updateDoc(docRef, data));
    }
}
